export function getChoiceKey(participantIndex: number, sectionIndex: number): string {
    return `${getParticipantKey(participantIndex)}_section_${sectionIndex}`;
}

export function getParticipantKey(participantIndex: number): string {
    return `participant_${participantIndex}`;
}
